module.exports = __webpack_public_path__ + "img/partner3.224959f8.png";